// extracted by mini-css-extract-plugin
export var resizer = "_go-0";